import React, { useState, useEffect } from "react";
import axios from "axios";
import DefaultLayout from "../components/DefaultLayout";
import { EyeOutlined,CloseOutlined, CaretDownOutlined, CaretUpOutlined,  } from "@ant-design/icons";
import { Input, Collapse, message, Button, Empty, Select } from "antd";
import Invoice from "../components/Invoice.js";
import "./Invoice.css";
import ReactDOM from "react-dom";
import App from "../App";
import logo from "../assets/images/logo.png";
import config from "../config";

const { Search } = Input;
const { Panel } = Collapse;

const Reports = () => {
  const apiBaseUrl = config.REACT_APP_API_BASE_URL;

  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [invoiceData, setInvoiceData] = useState(null);
  const [activeKey, setActiveKey] = useState(["1"]); // Open by default
  const [searchValue, setSearchValue] = useState("");
  const [latestTenInvoices, setLatestTenInvoices] = useState([]);
  const [invoiceStatusOpen, setInvoiceStatusOpen] = useState(false);

  const fetchInvoiceData = async (invoiceId) => {
    try {
      const { data } = await axios.get(
        `${apiBaseUrl}/api/payments/${invoiceId}`
      );
      setInvoiceData(data);
      console.log("invoice data:", data);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        message.error("Invoice not found.");
      } else {
        message.error("Error fetching invoice data.");
      }
      setInvoiceData(null);
    }
  };
const handleInvoiceStatusDropdownVisibleChange = (open) => {
    setInvoiceStatusOpen(open);
  };
    const getLatestTenInvoices = async () => {
    try {
      const { data } = await axios.get(
        `${apiBaseUrl}/api/payments/latest`
      );
      setLatestTenInvoices(data);
      if(data){
        setSelectedInvoiceId(data[0].invoiceId);
        setSearchValue(data[0].invoiceId);
        onSearch(data[0].invoiceId);
      }
    } catch (error) {
      message.error("Something Went Wrong");
    } 
  };

  useEffect(() => {
    getLatestTenInvoices();
  }, []);

  const onSearch = (value) => {
    const invoiceId = value.trim();
    setSelectedInvoiceId(invoiceId || null);

    if (invoiceId) {
      fetchInvoiceData(invoiceId);
    } else {
      setInvoiceData(null);
    }
  };

  const handleClear = () => {
    setSearchValue("");
    setSelectedInvoiceId(null);
    setInvoiceData(null);
  };

  const handlePrint = () => {
    const invoiceContent = document.getElementById("invoice-content");

    if (invoiceContent) {
      // Create a hidden iframe for printing
      const printFrame = document.createElement("iframe");
      printFrame.style.position = "absolute";
      printFrame.style.top = "-10000px";
      document.body.appendChild(printFrame);

      const printDoc =
        printFrame.contentDocument || printFrame.contentWindow.document;

      // Write the content for printing
      printDoc.open();
      printDoc.write(`
        <html>
          <head>
            <title>Invoice</title>
            <link rel="stylesheet" href="/" />
            <style>
                @media print {
                body {
                    margin: 0;
                    padding: 0;
                    width: 80mm;
                    height: auto;
                    overflow: hidden;
                    font-family: Arial, sans-serif;
                    page-break-after: always;
                }

                #invoice-content {
                    width: 80mm; 
                    padding: 0px;
                    font-family: Arial, sans-serif;
                    font-size: 12px;
                    line-height: 1.2;
                    color: #000;
                }

                .print-header {
                  display: none; /* This will hide the header */
                }

                // @page {
                //     size: A4;
                //     margin: 0;
                // }
                    
                .receipt-container {
                    transform: scale(0.95)!important;  
                    transform-origin: top center;
                    margin: 0 !important;
                    padding:0 !important;
                    border:none !important;
                    border-radius:0 !important;

                }

                .receipt-header {
                    text-align: center;
                    margin-bottom: 10px;
                }

                .receipt-header img {
                    width: 100%; 
                    max-width: 200px;
                    height: auto;
                    margin-bottom: 5px;
                }

                .receipt-header p {
                    margin: 15px;
                    font-size: 16px;
                    
                }

                .receipt-details p {
                    margin: 2px 0;
                    font-size: 17spx;
                }

                .receipt-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin: 10px 0;
                }

                .receipt-table th, .receipt-table td {
                    text-align: left;
                    padding: 5px 0;
                    font-size: 16px;
                    border: none;
                }

                .receipt-row {
                    display: flex;
                    justify-content: space-between;
                    font-size: 16px;
                    margin: 5px 0;
                }

                .separator {
                    text-align: right;
                    margin: 5px 0;
                    border-top: 1px dashed #000;
                    height: 1px;
                    width: 100%;
                }

                .receipt-footer {
                    text-align: center;
                    margin-top: 60px;
                    
                }

                .receipt-footer p {
                    margin: 0;
                    font-size: 20px;
                }

                * {
                    box-shadow: none !important;
                    background: none !important;
                }

                .receipt-container, .receipt-row, .receipt-table {
                    page-break-inside: avoid;
                }
            }
            </style>
          </head>
          <body>
            
            ${invoiceContent.outerHTML}
          </body>
        </html>
      `);
      printDoc.close();

      // Trigger print dialog
      printFrame.contentWindow.focus();
      printFrame.contentWindow.print();

      // Clean up the iframe after printing
      // setTimeout(() => {
      //   document.body.removeChild(printFrame);
      // }, 1000);
    } else {
      console.error("Invoice content not found.");
      message.error("Invoice content is not available for printing.");
    }
  };

  return (
    <DefaultLayout>
      <div className="report-container">
        <div className="report-content">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="page-header">
              <h1 className="page-title">Invoice History</h1>
            </div>

            <div
              style={{
                
                display: "flex",
                alignItems: "center",
              }}
            >
              <h6
                style={{
                  marginBottom: 0,
                  marginRight: "5px",
                }}
              >
                Ten Latest Invoice:{" "}
              </h6>

              <Select
                value={searchValue}
                  onChange={(value) => {
                  const upperValue = value.toUpperCase();
                  setSearchValue(upperValue);
                  onSearch(upperValue);
                }}
                onDropdownVisibleChange={handleInvoiceStatusDropdownVisibleChange}
                suffixIcon={
                  invoiceStatusOpen ? <CaretUpOutlined /> : <CaretDownOutlined />
                }
                style={{ minWidth: '200px' }}
              >
                { latestTenInvoices.map((invoice) => (
                  <Select.Option key={invoice.invoiceId} value={invoice.invoiceId}>
                    {invoice.invoiceId}
                  </Select.Option>
                ))}
              </Select>
            </div>
            
          </div>
          <Search
            placeholder="Search by Invoice ID"
            onSearch={onSearch}
            enterButton
            value={searchValue} // Bind value to state
            onChange={(e) => {
              setSearchValue(e.target.value.toUpperCase())
              onSearch(e.target.value.toUpperCase());
              setSearchValue(e.target.value.toUpperCase());

            }} // Convert input to uppercase
            suffix={
              <CloseOutlined
                style={{
                  visibility: searchValue ? "visible" : "hidden", // Keep the icon rendered but hide it when no input
                  cursor: "pointer",
                  color: "rgba(0, 0, 0, 0.45)",
                }}
                onClick={handleClear}
              />
            }
          />
         
          {selectedInvoiceId ? (
            invoiceData &&
            invoiceData.orderDetails &&
            invoiceData.orderDetails.length > 0 ? (
              <div>
                <Collapse
                  defaultActiveKey={["1"]}
                  style={{ marginTop: "20px" }}
                  className="collapse-invoice"
                  activeKey={activeKey}
                  onChange={(key) => setActiveKey(key)} // Allow user interaction to open/close panels
                >
                  <Panel
                    header={`Details for Invoice: ${selectedInvoiceId}`}
                    key="1"
                  >
                    <div
                      className="card-invoice"
                      style={{
                        marginTop: "20px",
                        width: "50%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Invoice orders={invoiceData} />
                    </div>
                  </Panel>
                </Collapse>
              </div>
            ) : (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No data available for this invoice."
                style={{ marginTop: "20px" }}
              />
            )
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No data available."
              style={{ marginTop: "20px" }}
            />
          )}
        </div>
      </div>
    </DefaultLayout>
  );
};

export default Reports;
